import React from 'react';
import { NodeProps } from 'reactflow';
import styled from 'styled-components/macro';
import { ReactComponent as Fire } from '../../../images/icons/fire-solid.svg';
import { colourPurple09, colourPurple10 } from '../../../styling/colours';

import { HeatSourceMapNodeData } from '../../shared/quote-or-design-form/map/mapNode';
import { MapFlowNodeReadOnly } from './MapFlowNodeReadOnly';

export const ReadOnlyHeatSource = ({ data: { heatSource } }: NodeProps<HeatSourceMapNodeData>) => {
  return (
    <HeatSourceFlowNode
      icon={<HeatSourceIcon />}
      hasSource={true}
      hasTarget={false}
      stats={[heatSource ?? '']}
      title="Heat Source"
    />
  );
};

const HeatSourceIcon = styled(Fire)`
  height: 1em;
  width: 1em;
`;

const HeatSourceFlowNode = styled(MapFlowNodeReadOnly)`
  border-color: ${colourPurple09};
  background: ${colourPurple10};
`;
